import { defineVideoTemplate } from "@assets/templates/builders";
import { BASE_ASSETS } from "@assets/templates/constants";

export const tennisRallyExample = defineVideoTemplate({
  slug: "tennis-rally-example",
  title: "Tennis rally",
  description: "Player tracking",
  subdescription: "Follow each player throughout the rally",
  poster: BASE_ASSETS.tennisRallyPoster,
  video: BASE_ASSETS.tennisRallyVideo,
  prompt: "Track each player.",
  featured: true,
  temperature: 0,
  annotationFormat: "box",
  enableThinking: false,
});
